module.exports = __webpack_public_path__ + "img/bg.73d4c294.jpg";